import React, { memo } from 'react';

const Tooltip = memo(() => {
    return (
        <div className="w5-popover">
            <div className="w5-popover-content"></div>
            <div className="w5-popover-arrow" data-popper-arrow></div>
        </div>
    );
});

export default Tooltip;
